import { render } from "./BalTabsSwitch.vue?vue&type=template&id=2928d304&scoped=true&ts=true"
import script from "./BalTabsSwitch.vue?vue&type=script&lang=ts"
export * from "./BalTabsSwitch.vue?vue&type=script&lang=ts"

import "./BalTabsSwitch.vue?vue&type=style&index=0&id=2928d304&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2928d304"]])

export default __exports__